module.exports = __webpack_public_path__ + "media/images/lb/835-f412d1c09056d48ba5bdc145c0e9c98e.svg";